"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const analytics_js_1 = __importDefault(require("@hh.ru/analytics-js"));
/** Успешный таргетированный отклик соискателя после нажатия на кнопку Откликнуться:<ul><li>в карточке вакансии в поиске</li><li>на карте</li><li>на странице вакансии</li></ul> */
const vacancyTargetingResponseCompleteExternal = () => analytics_js_1.default.sendEvent("applicant", "target-response-sent");
exports.default = vacancyTargetingResponseCompleteExternal;
